import React, { useState, useEffect, memo, useCallback } from "react";

import style from "./../index.module.scss";
import styleUi from "./EditPassword.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import LogItem from "../../comm/global/components/LogItem";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';

// 使用 React.memo 包装 PasswordBox 组件
const PasswordBox = memo(({ label, index, passwords, focusIndex, setFocusIndex, setPasswords,setErrorMsg,hasError, setHasError ,set_canSumbit,addModalType}) => {
    const [showPassword, setShowPassword] = useState(false);

    const handlePasswordChange = useCallback((e) => {
        set_canSumbit(false);
        setPasswords(prev => {
            const newPasswords = [...prev];
            newPasswords[index] = e.target.value;
            return newPasswords;
        });
    }, [index, setPasswords]);

    const handleFocus = useCallback(() => {
        setFocusIndex(index);
    }, [index, setFocusIndex]);
    const handleBlur = useCallback(() => {
        setErrorMsg("");
        let _errorMsg="";
        const _hasError=[false,false,false];
        setHasError([false,false,false]);
        //檢查格式
        for (var i = 0; i < 3; i++) {
            const password = passwords[i];
            if(password!=="")
            {
                const isValid = /^[A-Za-z0-9]{6,}$/.test(password);
                if (!isValid) {
                    console.log("Invalid password at index:", i);
                    _hasError[i]=true;
                    _errorMsg="請輸入正確格式。";
                    
                }
            }
        }
        if(_errorMsg!=="")
        {
            setErrorMsg(_errorMsg);
            setHasError(_hasError);
            return;
        }
        if(passwords[1]!==""&&passwords[2]!==""&&passwords[1]!==passwords[2])
        {
            setErrorMsg("你輸入的新密碼不一致");
            setHasError([false,true,true]);
            return;
        }
        if(passwords[0]==passwords[1])
            {
                setErrorMsg("新密碼不得於目前密碼相同");
                setHasError([false,true,true]);
                return;
            }
        if(passwords[0]!==""&&passwords[1]!==""&&passwords[2]!=="")
        {
            set_canSumbit(true);
        }
        //
    }, [index, passwords,setFocusIndex]);

    return (
        <YStyled.Col gap="1rem" style={{ marginTop: "1rem" }}>
            <YStyled.Row>
                <YStyled.Span id="password" size={15} fontWeight={500}>{label}</YStyled.Span>
                {index === 0 && (
                    <YStyled.Span size={15} color="#5BA5FE" fontWeight={500} style={{ cursor: "pointer" }} onClick={e=>{
                        addModalType({cls:"SendLostPassword"})
                    }}>忘記密碼？</YStyled.Span>
                )}
            </YStyled.Row>
            <YStyled.Label className={`${styleUi.inputLabel} ${hasError[index] ? styleUi.error : ""} ${focusIndex === index ? styleUi.focus : ""}`}
                style={{ padding: ".5rem .8rem", borderRadius: "9px", background: "#fff", width: "100%", justifyContent: "flex-start" }}>
                <YStyled.Input
                    id={`password-${index}`}
                    value={passwords[index]}
                    size={17}
                    type={showPassword ? "text" : "password"}
                    placeholder="請輸入"
                    onChange={handlePasswordChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    maxLength={12}
                />
                {showPassword ? (
                    <VisibilityIcon onClick={() => setShowPassword(false)} />
                ) : (
                    <VisibilityOffIcon onClick={() => setShowPassword(true)} />
                )}
            </YStyled.Label>
        </YStyled.Col>
    );
});

const EditPassword = ({ setModalType,addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [h, setH] = useState(0);
    const [focusIndex, setFocusIndex] = useState(-1);
    const [passwords, setPasswords] = useState(["", "", ""]);
    const [errorMsg, setErrorMsg] = useState("");
    const [hasError, setHasError] = useState([false,false,false]);
    const [canSumbit, set_canSumbit] = useState(false);

    const adjustButtonPosition = () => {
        const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        setH(window.innerHeight - viewportHeight);
    };

    useEffect(() => {
        setInProp(true);
        document.title = "變更密碼";
        const handleResize = () => {
            adjustButtonPosition();
        };
        const viewport = window.visualViewport;
        if (viewport) {
            viewport.addEventListener('resize', adjustButtonPosition);
            viewport.addEventListener('scroll', adjustButtonPosition);
        } else {
            window.addEventListener('resize', handleResize);
        }
        adjustButtonPosition();
        return () => {
            if (viewport) {
                viewport.removeEventListener('resize', adjustButtonPosition);
                viewport.removeEventListener('scroll', adjustButtonPosition);
            } else {
                window.removeEventListener('resize', handleResize);
            }
        };
    }, []);

    return (
        <div className={style.modal}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.SwipePageEnterActive,
                enterDone: style.SwipePageEnterDone,
                exitActive: style.SwipePageExit,
                exitDone: style.SwipePageExitActive
            }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "EditPassword"))
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`} >
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={() => setInProp(false)} />
                        </div>
                        <div className={styleUi.view}>
                            <PasswordBox label="目前密碼" index={0} passwords={passwords} focusIndex={focusIndex} setFocusIndex={setFocusIndex} setPasswords={setPasswords} setErrorMsg={setErrorMsg} hasError={hasError} setHasError={setHasError} set_canSumbit={set_canSumbit} addModalType={addModalType}/>
                            <PasswordBox label="新密碼" index={1} passwords={passwords} focusIndex={focusIndex} setFocusIndex={setFocusIndex} setPasswords={setPasswords}  setErrorMsg={setErrorMsg} hasError={hasError} setHasError={setHasError} set_canSumbit={set_canSumbit} addModalType={addModalType}/>
                            <PasswordBox label="確認新密碼" index={2} passwords={passwords} focusIndex={focusIndex} setFocusIndex={setFocusIndex} setPasswords={setPasswords}  setErrorMsg={setErrorMsg} hasError={hasError} setHasError={setHasError} set_canSumbit={set_canSumbit} addModalType={addModalType}/>
                            <YStyled.Span color="#3C3C43" fontWeight={400} size={13} style={{ alignSelf: "flex-start", marginTop: "1rem" }} >*密碼需為6-12位數字及英文字母，區分大小寫</YStyled.Span>
                            <YStyled.Span color="#C81E1E" fontWeight={400} size={13} style={{ alignSelf: "flex-start", marginTop: "1rem" }} >{errorMsg}</YStyled.Span>
                            <YStyled.BTN3 disabled={!canSumbit} normalBg="#F2CE3E" disableBg="#CCCCCC" disableColor="#ffffff" hoverBg="F8F8F8" normalColor="black" className={styleUi.sumbitBtn} style={{ bottom: `${h + 40}px` }} id="sumbitBtn" onClick={e=>{
                                setErrorMsg("你輸入的舊密碼不正確");
                                setHasError([true,false,false])
                            }}>
                                <YStyled.Span size={17} >變更</YStyled.Span>
                            </YStyled.BTN3>
                        </div>
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
};

export default React.memo(EditPassword);
